import React from 'react';
import NavBar from '../navBar/NavBar';
import './App.scss';

const App = () => (
  <NavBar/>
);

export default App;
